module.exports = __webpack_public_path__ + "static/digital payments-7805cc19282a8da5db44d6583802ddce.png";